import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumAssemblyOutputTarget implements BaseEnumType {
  private static allValues: EnumAssemblyOutputTarget[] = []; // make sure this is top-most
  
  public static stock = new EnumAssemblyOutputTarget(0, "Stock", "enum_assembly_output_target_stock");
  public static assembly = new EnumAssemblyOutputTarget(1, "Assembly", "enum_assembly_output_target_assembly");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumAssemblyOutputTarget.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isStock() { return this === EnumAssemblyOutputTarget.stock; }
  public isAssembly() { return this === EnumAssemblyOutputTarget.assembly; }

  public static getValues(): readonly EnumAssemblyOutputTarget[] {
    return EnumAssemblyOutputTarget.allValues;
  }

  public static getValuesExcept0(): readonly EnumAssemblyOutputTarget[] {
    return EnumAssemblyOutputTarget.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumAssemblyOutputTarget {
    const found = EnumAssemblyOutputTarget.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumAssemblyOutputTarget - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumAssemblyOutputTarget): EnumAssemblyOutputTarget {
    const found = name ? EnumAssemblyOutputTarget.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumAssemblyOutputTarget - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumAssemblyOutputTarget>): boolean {
    return this.key === other?.key;
  }
}